// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducerad) return;

  const VARAKTIGHET = 220;
  const EASE        = 'cubic-bezier(0.4, 0, 0.2, 1)';

  const html = document.documentElement;
  const body = document.body;

  const fadeIn = () => {
    delete html.dataset.laddas;
    delete body.dataset.sidovergång;
  };

  const fadeOut = () => new Promise((resolve) => {
    body.dataset.sidovergång = 'ute';
    setTimeout(resolve, VARAKTIGHET);
  });

  fadeIn();

  document.addEventListener('click', async (e) => {
    const lank = e.target.closest('a[href]');
    if (!lank) return;

    const href = lank.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) return;
    } catch (_) { return; }

    if (lank.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    await fadeOut();
    window.location.assign(lank.href);
  });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) fadeIn();
  });
})();

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || reducerad) return;

  const gsap = window.gsap;
  if (window.CSSPlugin) gsap.registerPlugin(window.CSSPlugin);
  const varaktighet = { val: 0.22, aval: 0.14 };

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.produkt-sida__alternativ-radio');
    if (!radio) return;

    const form = radio.closest('form');
    if (!form) return;
    const allRadios = form.querySelectorAll(`.produkt-sida__alternativ-radio[name="${CSS.escape(radio.name)}"]`);

    allRadios.forEach((r) => {
      if (r === radio) {
        gsap.to(r, {
          '--variant-radie': '50%',
          duration: varaktighet.val,
          ease: 'power2.out',
          overwrite: 'auto',
        });
      } else {
        gsap.to(r, {
          '--variant-radie': '0%',
          duration: varaktighet.aval,
          ease: 'power2.in',
          overwrite: 'auto',
        });
      }
    });
  });
})();

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || reducerad) return;

  const gsap = window.gsap;
  const tryckIn = { '--atgard-radie': '6px', '--atgard-filter': 'blur(1.5px)', duration: 0.12, ease: 'power2.out', overwrite: 'auto' };
  const tryckUt = { '--atgard-radie': '0px', '--atgard-filter': 'blur(0px)', duration: 0.18, ease: 'power2.in', overwrite: 'auto' };

  const aterstall = (el) => { if (el) gsap.to(el, tryckUt); };

  document.addEventListener('pointerdown', (e) => {
    const el = e.target.closest('[data-action~="atgard/tryck"]');
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    gsap.to(el, tryckIn);
    const slapp = () => { aterstall(el); el.removeEventListener('pointerup', slapp); el.removeEventListener('pointerleave', slapp); };
    el.addEventListener('pointerup', slapp);
    el.addEventListener('pointerleave', slapp);
  });
})();

(() => {
  document.addEventListener('click', (e) => {
    const fore = e.target.closest('[data-action~="kortbild/fore"]');
    const nasta = e.target.closest('[data-action~="kortbild/nasta"]');
    const knapp = fore || nasta;
    if (!knapp) return;

    e.preventDefault();
    const kort = knapp.closest('.kort');
    if (!kort) return;

    const bilder = Array.from(kort.querySelectorAll('.kort__bild img'));
    if (bilder.length < 2) return;

    const synlig = bilder.findIndex((b) => b.dataset.state !== 'dold');
    const aktiv = synlig === -1 ? 0 : synlig;
    const riktning = fore ? -1 : 1;
    const nasta_index = (aktiv + riktning + bilder.length) % bilder.length;

    bilder.forEach((b, i) => {
      b.dataset.state = i === nasta_index ? '' : 'dold';
    });

    const indexSpan = kort.querySelector('[data-kortindex]');
    if (indexSpan) {
      const total = parseInt(knapp.closest('[data-kortbild-total]')?.dataset.kortbildTotal || bilder.length, 10);
      indexSpan.textContent = `${nasta_index + 1} / ${total}`;
    }
  });
})();
